import { Component, h, Prop, Element } from '@stencil/core';
import { getLinkTargetAttrs } from '../component-utils/ctaUtils';

@Component({
  tag: 'aafp-link',
  shadow: false,
})
export class AafpLink {
  @Element() element: HTMLElement;
  @Prop() dataIsExternalLink: boolean = false;
  @Prop({ mutable: true }) dataUrl: string = '';
  @Prop() dataText: string;
  @Prop() dataAriaLabel?: string;
  @Prop({ mutable: true }) dataIsRestricted = false;
  @Prop({ mutable: true }) navMenuEvent = false;
  @Prop() analyticsLabel: string;

  /**
   * Checks anchor links to see if jump target is on same
   * page to guard against rerendering
   * @param url
   * Returns the original url if jump target is not on the current page
   * or just the jump target id if it is on same page
   */
  public verifyJumpTargetHref(url: string) {
    let href = url;
    const pattern = new RegExp(window.location.pathname);
    if (pattern.test(url)) {
      href = url.replace(pattern, '');
    }
    return href;
  }

  render() {
    const hashTag: boolean = Array.from(this.dataUrl).includes('#');
    const url = hashTag ? this.verifyJumpTargetHref(this.dataUrl) : this.dataUrl;
    const attrs: { [key: string]: any } = {
      ...getLinkTargetAttrs(this.dataIsExternalLink),
      class: 'adl-link',
      href: url,
    };
    if (this.navMenuEvent) {
      attrs.onClick = () => {
        window.localStorage.setItem('prop31', `${this.analyticsLabel}:${this.dataText}`);
      };
    }
    return (
      <a aria-label={this.dataAriaLabel} {...attrs} innerHTML={this.dataText}>
        {this.dataIsRestricted && (
          <i class="adl-link__restricted adl-link__restricted--show material-icons" data-icon="vpn_key"></i>
        )}
      </a>
    );
  }
}
